module.exports = " <div class=confirm v-show=isShowConfirm transition=confirm _v-07f8688c=\"\"> <div class=confirm-dialog _v-07f8688c=\"\"> <div class=confirm-body _v-07f8688c=\"\"> <slot name=body _v-07f8688c=\"\"></slot> </div> <div class=\"confirm-footer clearfix\" _v-07f8688c=\"\"> <slot name=footer _v-07f8688c=\"\"> <div class=cancelBtn @click=hide _v-07f8688c=\"\">取消</div> <div class=confirmBtn @click=confirmHandler _v-07f8688c=\"\">确认</div> </slot> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-07f8688c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vConfirm.vue
 ** module id = 86
 ** module chunks = 2
 **/